import styled from 'styled-components';
import MiniCard from '../MiniCard';

export const Container = styled.div`
  background-color: #fff;
  padding: 2px;
`;

export const MiniCardWrapper = styled(MiniCard)`
  margin-bottom: 5px;
`;
